import {StateSelector} from './type';

export const getValueUser = (store: StateSelector) => store.statisticReducer.recipientFilter;

export const getValueTeam = (store: StateSelector) => store.statisticReducer.recipientTeamFilter;

export const getValueAuthor = (store: StateSelector) => store.statisticReducer.authorFilter;

export const getFeedbacks = (store: StateSelector) => store.statisticReducer.feedbacks;

export const getDerection = (store: StateSelector) => store.statisticReducer.derection;
